import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AssetTransfer, AssetTransferCreate, AssetTransferFilter } from '../data/assetTransfer';

export function createAssetTransferService(client: AxiosInstance) {
  return createCrudService<AssetTransfer, AssetTransferCreate, AssetTransferFilter>(
    client,
    '/asset-management/AssetTransfer',
    'id',
  );
}

export type AssetTransferService = CrudService<AssetTransfer, AssetTransferCreate, AssetTransferFilter>;
